import { getAdmins } from '@services/queries'
import { useQuery } from 'react-query'

export function useAdmins() {
  const info = useQuery(['admins'], getAdmins)

  return info
}
